import React, { useEffect, useState } from 'react'
import InterviewSchedule from './InterviewSchedule'
import MobileHeader from '../../components/header/MobileHeader'
import LoginHeader from '../../components/header/LoginHeader'
import Footer from '../../components/footer'
import Gotop from '../../components/gotop'
import Breadcrumb from '../../components/breadcrumb'
import Pricing3 from '../../components/pricing/Pricing3'
import InstituteHeader from '../../components/header/InstituteHeader'
import CRHeader from '../../components/header/CRHeader'
import NonLoginHeader from '../../components/header/NonLoginHeader'
import LoginMobileHeader from '../../components/header/LoginMobileHeader'
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader'
import CRMobileHeader from '../../components/header/CRMobileHeader'
import { Helmet } from 'react-helmet'
// import { Breadcrumb } from 'react-bootstrap'
// import Breadcrumb from "../components/breadcrumb";


const InterviewAndSchedule = () => {
  const [isShowMobile, setShowMobile] = useState(false);

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);
  const module = localStorage.getItem('Module')
  return (
    <>
     <Helmet>
				<title>Interviews | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Interviews | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
      {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
          module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
              <MobileHeader handleMobile={handleMobile} />}

      {module === 'Candidate' ? <LoginHeader clname="applications" handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteHeader clname="applications" handleMobile={handleMobile} /> :
          module === 'Company' ? <CRHeader clname="applications" handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRHeader clname="applications" handleMobile={handleMobile} /> :
              <NonLoginHeader clname="applications" handleMobile={handleMobile} />}

      <div className="pt-70">
        <InterviewSchedule />
        {/* <Pricing3 /> */}
        {/* <Footer /> */}
        <Gotop />
      </div>
    </>
  )
}

export default InterviewAndSchedule